import { FC } from 'react';
import { Footer } from 'layouts/Footer';
import Header from 'layouts/Header';
import { Helmet } from 'react-helmet';
import { IS_NEMAN } from 'services/constants/env';
import { useRequireAuth } from 'routes/useRequireAuth';
import { EASSpinner } from 'components/EASSpinner';
import { TPageProps } from './types';

// ==========================================:
export const Page: FC<TPageProps> = ({ children, title }) => {
	const ifAuth = useRequireAuth();

	if (!ifAuth) return <EASSpinner />;

	return (
		<div className="wrapper">
			<Helmet>
				<title>{title}</title>
				<link rel="icon" href={`${IS_NEMAN ? '/favicon-neman.ico' : '/favicon.ico'}`} />
			</Helmet>
			<Header />
			<main className="main">
				<div className="main-content">{children}</div>
			</main>
			<Footer />
		</div>
	);
};
